export const specimenDetailCn = {
    xunjiadang:'基本信息',
    dingdangbianhao:'订单编号',
    chuangjianshijian:'创建时间',
    jifang:'寄方',
    shoufang:'收方',
    yangpingzhuantai:'样品状态',
    yangpingxinxi:'样品信息',
    yangpingmingcheng:'样品名称',
    shuliang:'数量',
    laiyuan:'来源',
    shifouhuishou:'是否回收',
    beizhu:'备注',
    wuliougenzhong:'物流跟踪',
    xuhao:'序号',
    shoujianren:'收件人',
    lianxihaoma:'联系号码',
    xiangxidizhi:'详细地址',
    wulioudanghao:'物流单号',
    wuliouleixing:'物流类型',
    caozuo:'操作',
    caozuoxinxi:'操作信息',
    caozuoren:'操作人',
    zhengshuzhuantai:'样品状态',
    caozuoshijian:'操作时间',
    fanhuidingdang:'返回样品列表'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/specimenDetail/specimenDetailCn.js